import { useFormState } from 'react-hook-form';
import { FormError } from 'shared/components/FormControl';
import styled from 'styled-components';

import Form from 'dashboard/layouts/FormLayout/Form';
import Button from 'design-system/components/Button';
import Input from 'design-system/components/Input';
import Spacer from 'design-system/components/Spacer';
import { Label } from 'design-system/components/Text';
import { FREE_EMAIL_PROVIDER_REGEX } from 'lib/constants/regexes';
import { useFormSecurely } from 'lib/security/reactHookForm';

interface FormRegisterChangeEmailProps {
  savedEmail: string;
  cancel: () => void;
  submit: (data: FormRegisterChangeEmailData) => void;
}

export const FormRegisterChangeEmail = ({
  savedEmail,
  cancel,
  submit,
}: FormRegisterChangeEmailProps) => {
  const { control, handleSubmit, register } = useFormSecurely<FormRegisterChangeEmailData>({
    defaultValues: {
      'email-address': savedEmail,
    },
  });
  const { isSubmitting, errors } = useFormState({
    control,
  });

  return (
    <Container>
      <Form onSubmit={handleSubmit(submit)}>
        <Label htmlFor='email-address' size='lg' weight='bold'>
          Updated email address
        </Label>
        <Spacer height={1} />
        {errors['email-address'] && <FormError>{errors['email-address'].message}</FormError>}
        <Input
          {...register('email-address', {
            required: 'Please enter a business email address',
            pattern: {
              value: FREE_EMAIL_PROVIDER_REGEX,
              message: 'Please enter a valid business email address.',
            },
          })}
          id='email-address'
          data-test='form-register__change-email'
          type='text'
        />
        <Spacer height={2} />

        <Button
          data-test='form-register__change-email-submit'
          type='submit'
          disabled={isSubmitting}
          isPending={isSubmitting}
        >
          Update and resend
        </Button>
        <Spacer height={1} />
        <Button
          type='button'
          variant='basic'
          onClick={cancel}
          disabled={isSubmitting}
          isPending={isSubmitting}
        >
          Cancel
        </Button>
      </Form>
    </Container>
  );
};

const Container = styled('div')`
  width: 100%;
  max-width: 500px;
`;

export interface FormRegisterChangeEmailData {
  'email-address': string;
}

export default FormRegisterChangeEmail;
